import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("SYMIN");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Signed in");
      const pending = localStorage.getItem("symin-pending-module");
      localStorage.removeItem("symin-pending-module");
      const isSuper = u?.role === "super_admin";
      const am = u?.active_modules || [];
      if (pending) {
        const key = pending.replace(/^\//, "");
        if (isSuper || am.includes(key)) { nav(pending); return; }
        nav("/console"); return;
      }
      if (isSuper) { nav("/admin"); return; }
      if (u?.role === "admin") { nav("/projects"); return; }
      if (am.length === 1) { nav("/" + am[0]); return; }
      nav("/console");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid="login-page">
      <header className="h-16 flex items-center px-5 sm:px-8">
        <Link to="/" data-testid="login-home">
          <img src="/symin-logo.png" alt="SYMIN" className="h-8 w-auto object-contain" />
        </Link>
      </header>

      <main className="flex-1 flex items-center justify-center px-5 py-10">
        <div className="w-full max-w-[420px] animate-fade-in">
          <div className="rounded-2xl border border-slate-200 bg-white p-8 sm:p-10">
            <div className="flex justify-center mb-7">
              <img src="/symin-logo.png" alt="SYMIN" className="h-11 w-auto object-contain" data-testid="login-card-logo" />
            </div>
            <div className="text-center mb-7">
              <p className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#C20511]">Sign in</p>
              <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900 mt-1.5">Welcome back</h1>
              <p className="text-sm text-slate-500 mt-2">Access your exploration console.</p>
            </div>

            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email" className="text-slate-700">Username</Label>
                <Input id="email" data-testid="login-email" type="text" autoCapitalize="none" autoCorrect="off"
                  value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 h-11" />
              </div>
              <div>
                <Label htmlFor="password" className="text-slate-700">Password</Label>
                <Input id="password" data-testid="login-password" type="password" value={password}
                  onChange={(e) => setPassword(e.target.value)} required className="mt-1.5 h-11" />
              </div>
              <Button type="submit" data-testid="login-submit" disabled={loading} className="w-full h-11 text-sm font-bold">
                {loading ? "Signing in…" : "Sign in"}
              </Button>
            </form>

            <p className="text-sm text-slate-500 text-center mt-6">
              No account? <Link to="/register" className="text-[#C20511] font-semibold hover:underline" data-testid="go-register">Register</Link>
            </p>
          </div>

          <p className="text-center text-[12px] text-slate-400 mt-6">
            © {new Date().getFullYear()} SYMIN · Shanvi Resources
          </p>
        </div>
      </main>
    </div>
  );
}
